<template>
	<tr class="md-table-row">
		<td class="md-table-cell md-table-measures">
			<div v-if="!isEditing" class="md-table-cell-container wizard-data">{{ label }}</div>
			<input ref="inputValue" v-if="isEditing && inputType != 'textarea'" type="text" class="md-table-cell-container m-left-10 wizard-data" v-model="changed" placeholder="Value" @input="sanitizeChanged">
			<textarea ref="inputValue" v-if="isEditing && inputType == 'textarea'" v-model="changed" class="form-control input-value pt-input input-focus m-left-10 mt-10 mb-10" placeholder="Value..." @input="sanitizeChanged"></textarea>
		</td>
		<td class="md-table-cell md-table-measures">
			<div class="md-table-cell-container wizard-buttons m-left-5">
				<!-- Is editing -->
				<template v-if="isEditing">
					<span @click="update()">
								<i class='fas fa-save small-icon picker-icon' aria-hidden="true"></i>
								<md-tooltip md-direction="left">Save</md-tooltip>
							</span>
					<span class="m-left-10" @click="cancel()">
								<i class='fas fa-times picker-icon-danger' aria-hidden="true"></i>
								<md-tooltip md-direction="right">Cancel</md-tooltip>
							</span>
				</template>
				<!-- Not editing -->
				<template v-if="!isEditing">
					<span @click="edit()">
								<i class="fa fa-edit small-icon" aria-hidden="true"></i>
								<md-tooltip md-direction="left">Edit</md-tooltip>
							</span>
					<span class="m-left-5" @click="remove()">
								<i class="fa fa-trash small-icon picker-icon-danger" aria-hidden="true"></i>
								<md-tooltip md-direction="right">Remove</md-tooltip>
							</span>
				</template>
			</div>
		</td>
	</tr>
</template>
<script>
import { sanitizeInput } from '../utils/sanitizer';
export default {
	name: "ConfigurationEditRow",
	props: ['label', 'index', 'inputType'],
	data() {
		return {
			isEditing: false,
			changed: ""
		}
	},
	watch: {
		label: "setChanged"
	},
	created() {
		this.setChanged();
	},
	methods: {
		sanitizeChanged(e) {
			this.changed = sanitizeInput(e.target.value);
		},
		setChanged() {
			this.changed = this.sanitizeInput(this.label);
		},
		sanitizeInput(input) {
			return sanitizeInput(input);
		},
		edit() {
			this.isEditing = true;
			this.$nextTick(() => {
				this.$refs.inputValue.focus();
			});
		},
		cancel() {
			this.isEditing = false;
			this.changed = this.label;
		},
		update() {
			this.isEditing = false;
			this.$emit("update", this.index, this.sanitizeInput(this.changed));
		},
		remove() {
			this.$emit("remove", this.index);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ConfigurationEditRow.vue